import jwtDecode from 'jwt-decode';
import { clearSelf } from './self';

const auth = ( admin ) => ({
    type: 'USER_LOGGED_IN',
    admin,
});

const deauthenticate = () => ( {
    type: 'LOGOUT',
} );

const checkingAuth = () => ({
    type:'CHECK_AUTH',
});

const checkedAuth = () => ({
    type:'CHECKED_AUTH',
});


const initialCheckTokens = function() {
    return dispatch => {
        dispatch( checkingAuth() );
        console.info( 'Checking Logged In State' );
        let token = window.localStorage.getItem( 'token' );
        var isLoggedIn = token != null;
        if( isLoggedIn ) {
            var decoded = jwtDecode(token);
            if (decoded.data.role === 'admin') {
                dispatch( auth(true) );
            } else {
                dispatch ( auth(false) );
            }
        } else {
            dispatch( checkedAuth() );
        }
        return isLoggedIn;
    };
};

const setTokens = function( tokens ) {
    return dispatch => {
        window.localStorage.setItem( 'token', tokens.token );
        window.localStorage.setItem( 'refreshToken', tokens.refreshToken );
        var decoded = jwtDecode(tokens.token);
        if (decoded.data.role === 'admin') {
            dispatch( auth(true) );
        } else {
            dispatch ( auth(false) );
        }
    };
};

const logout = function() {
    return dispatch => {
        window.localStorage.clear();
        dispatch( deauthenticate() );
        dispatch( clearSelf() );
    };
};

const directToHome = function() {
    return () => {
        window.location.href = '/';
    };
};

const directToLogin = function() {
    return () => {
        var currentLocation = window.encodeURIComponent( window.location.pathname );
        window.location.href = `/?login=true&redirect=${ currentLocation }`;
    };
};

export {
    auth,
    logout,
    initialCheckTokens,
    setTokens,
    directToHome,
    directToLogin,
};
